module.exports = __webpack_public_path__ + "static/media/ImpactStartupUpdated.05aef364.svg";